import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const CardNodeLabel = ({children, className}: any) => {
  return <label className={clsx('label', className)}>{children}</label>;
};

export {CardNodeLabel};

CardNodeLabel.propTypes = {
  /**
   * Pass in the children that will be rendered within the CardNodeLabel
   */
  children: PropTypes.node,

  /**
   * Provide an optional class to be applied on the outer element
   */
  className: PropTypes.string,
};
